import storage from '../utils/storage'
import { getNtpAppVersion } from '#imports'
/**
 * This plugin is used to migrate the app's local storage when the build version changes.
 * It checks the current build version against the stored version in local storage.
 * If the versions are different, it clears specific keys from local storage and updates the stored version.
 * The keys that are cleared are defined in the `clearKeys` array.
 * The current build version is obtained from the runtime configuration.
 * The plugin also provides the current build version and the storage object to the Nuxt app.
 */

/**
 * MOTIVATION:
 * 1. The app's local storage may contain data that is no longer relevant or compatible with the new build version.
 * 2. By clearing specific keys, we ensure that the app starts with a clean slate for the new build version.
 * 3. This helps prevent potential issues that may arise from using outdated or incompatible data.
 */

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const appVersion = getNtpAppVersion()
  const buildVersion = config.public.buildVersion || appVersion || 'next'
  try {
    // if query param is set to nocache, clear all storage
    if ('nocache' in nuxtApp._route.query) {
      console.log('Clearing all storage due to no-cache query param')
      storage.clear()
    }

    const storedVersion = storage.getItem('app:buildVersion')
    const clearKeys = [
      'app:config:adSettings',
      'app:config:layoutSettings',
      'app:config:layoutSkeleton',
      'app:config:siteSettings',
      'app:buildVersion',
    ]
    if (buildVersion !== storedVersion) {
      clearKeys.forEach((key) => {
        storage.removeItem(key)
      })
      storage.setItem('app:buildVersion', `${buildVersion}`)
    }
    // eslint-disable-next-line
  } catch (error) {
    /* empty */
  }
  nuxtApp.provide('buildVersion', buildVersion)
  nuxtApp.provide('storage', storage)
})
